import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Loader from 'components/Loader';
import APIErrorMascot from 'components/Mascot/APIErrorMascot';
import { useFetchEvvClientById } from 'hooks/evv/useFetchEvvClientById';

import ClientForm from '../shared/ClientForm';
import { initialClientFormData } from '../shared/ClientForm/schema';

const EditClient: React.FC<unknown> = () => {
  const [formData, setFormData] = useState<typeof initialClientFormData>(initialClientFormData);

  const { id } = useParams();

  const { data, status } = useFetchEvvClientById(id!);

  useEffect(() => {
    if (status === 'success') {
      const employeeApiData = data?.payload;

      const formData = {
        id: employeeApiData?.id || '',
        first_name: employeeApiData?.first_name || '',
        middle_name: employeeApiData?.middle_name || '',
        last_name: employeeApiData?.last_name || '',
        client_id: employeeApiData?.client_id || '',
        client_medicaid_id: employeeApiData?.client_medicaid_id || '',
        phone: employeeApiData?.phone || '',
        address_line_1: employeeApiData?.address_line_1 || '',
        address_line_2: employeeApiData?.address_line_2 || '',
        country: employeeApiData?.country || '',
        state: employeeApiData?.state || '',
        city: employeeApiData?.city || '',
        zip: employeeApiData?.zip || '',
        eligibility_start_date: employeeApiData?.eligibility_start_date
          ? new Date(employeeApiData.eligibility_start_date)
          : null,
        eligibility_end_date: employeeApiData?.eligibility_end_date
          ? new Date(employeeApiData.eligibility_end_date)
          : null,
        latitude: employeeApiData?.latitude || '',
        longitude: employeeApiData?.longitude || '',
        hiring_date: employeeApiData?.hiring_date ? new Date(employeeApiData.hiring_date) : null,
        jurisdiction_id: employeeApiData?.jurisdiction_id || '',
        procedure_code: employeeApiData?.procedure_code || '',
        client_status: employeeApiData?.client_status ? '1' : '0',
      };

      setFormData(formData);
    }
  }, [status, data]);

  if (status === 'loading') return <Loader />;
  if (status === 'error') return <APIErrorMascot />;

  return <ClientForm formData={formData} />;
};

export default EditClient;
